@let sweden = 2;

<div class="vesax-login">
  <form #loginForm="ngForm" (ngSubmit)="login(loginForm.form.valid)">
    <div class="form-group p-fluid">
      <p-dropdown
        #nationalityDropdown
        name="Nationality"
        inputId="Nationality"
        [options]="nationalities$ | async | coalesceTo : undefined"
        [(ngModel)]="nationalityId"
        (ngModelChange)="onNationalityChange($event)"
        #Nationality="ngModel"
        optionValue="id"
        [autoDisplayFirst]="false"
        placeholder="{{'SelectAnItem' | localize}}"
        required
      >
        <ng-template pTemplate="selectedItem">
          @let selected = (selected$ | async | coalesceTo: selectedDefault);
          @if(nationalityId) {
            <div class="country-item">
              <div class="famfamfam-flags {{selected[nationalityId].shortName}}"></div>
              <div>{{selected[nationalityId].name}}</div>
            </div>
          }
        </ng-template>
        <ng-template let-country pTemplate="item">
          <div class="country-item">
            <div class="famfamfam-flags {{country.shortName}}"></div>
            <div>{{country.name}}</div>
          </div>
        </ng-template>
      </p-dropdown>

      @if (Nationality.invalid && (Nationality.dirty)) {
        @if (Nationality.hasError('required')) {
          <small class="p-error" *ngIf="Nationality.hasError('required')">
            {{'ThisFieldIsRequired' | localize}}
          </small>
        }
      }
    </div>
    @if (nationalityId) {
      @if (nationalityId === sweden) {
        @for (option of loginOptions; track option.value) {
          <div class="mb-2">
            <p-radioButton name="selectedLoginOption" [value]="option.value" [label]="option.label | localize" [(ngModel)]="selectedLoginOption"></p-radioButton>
          </div>
        }
        @if (selectedLoginOption === 'BankID') {
          <button
            type="button"
            style="margin-bottom: 15px;"
            (click)="loginWithBankId.emit()"
            [buttonBusy]="authenticating"
          >
            {{ 'LogInWithBankId' | localize }}
          </button>
        } @else {
          <ng-container [ngTemplateOutlet]="withoutBankId"></ng-container>
        }
      } @else {
        <ng-container [ngTemplateOutlet]="withoutBankId"></ng-container>
      }
    }

    <ng-template #withoutBankId >
      @if(externalAuthProviders.length > 0) {
        <div class="login-with-account">
          <span>{{'LoginWith' }}</span>
          <!-- <ul>
              <li *ngFor="let provider of externalAuthProviders" [class.d-none]="provider.name === 'Facebook'">
                  <a href="javascript:;" (click)="externalAuthenticate(provider)" class="{{provider.icon}}"><i class='bx bxl-{{provider.icon}}'></i> {{provider.name}}</a>
              </li>
          </ul> -->
        </div>
      }
      @switch (currentRegularSignInPhase) {
        @case (regularSignInPhase.EmailCheckPending) {
          <ng-container [ngTemplateOutlet]="emailCheckPending"></ng-container>
        }
        @case (regularSignInPhase.EmailExists) {
          <ng-container [ngTemplateOutlet]="emailExists"></ng-container>
        }
        @case (regularSignInPhase.SocialRegisterPending) {
          <ng-container [ngTemplateOutlet]="socialRegisterPending"></ng-container>
        }
        @default {
          <ng-container [ngTemplateOutlet]="registerPending"></ng-container>
        }
      }

      <ng-template #emailCheckPending>
        <div class="form-group">
          <input
            type="email"
            id="LoginEmail"
            autocomplete="off"
            #LoginEmailInput="ngModel"
            [(ngModel)]="email"
            [placeholder]="'Email' | localize"
            class="form-control"
            name="email"
            email
            required
            (ngModelChange)="accountChecked = false"
          >
          <div *ngIf="LoginEmailInput.invalid && accountChecked">
            <small *ngIf="LoginEmailInput.hasError('required')" class="p-error">{{'ThisFieldIsRequired' | localize}}</small>
            <small *ngIf="LoginEmailInput.hasError('email')" class="p-error">{{'InvalidEmailAddress' | localize}}</small>
          </div>
      </div>
      <button type="button" [buttonBusy]="authenticating" (click)="checkForEmail(loginForm.form.valid)">{{ 'CheckForAccount' | localize}}</button>
      </ng-template>
      <ng-template #emailExists>
        <div class="form-group">
          <input
            type="email"
            id="LoginEmail"
            autocomplete="off"
            #LoginEmailInput="ngModel"
            [(ngModel)]="email"
            (ngModelChange)="currentRegularSignInPhase = regularSignInPhase.EmailCheckPending"
            [placeholder]="'Email' | localize"
            class="form-control"
            name="email"
            email
            required
          >
          <div *ngIf="LoginEmailInput.invalid && loginForm.submitted && LoginEmailInput.dirty">
            <small *ngIf="LoginEmailInput.hasError('required')" class="p-error">{{'ThisFieldIsRequired' | localize}}</small>
            <small *ngIf="LoginEmailInput.hasError('email')" class="p-error">{{'InvalidEmailAddress' | localize}}</small>
          </div>
        </div>
        <div class="form-group">
          <input
            id="Password"
            name="Password"
            autocomplete="current-password"
            [(ngModel)]="password"
            #LoginPasswordInput="ngModel"
            type="password"
            [placeholder]="'Password' | localize"
            class="form-control"
            required
          >
          <div *ngIf="LoginPasswordInput.invalid && loginForm.submitted && LoginPasswordInput.dirty">
            <small *ngIf="LoginPasswordInput.hasError('required')" class="p-error">{{'ThisFieldIsRequired' | localize}}</small>
            <small *ngIf="LoginPasswordInput.hasError('pattern')" class="p-error">{{'InvalidPattern' | localize}}</small>
          </div>
        </div>
        <button type="submit" [buttonBusy]="authenticating">{{ 'LoginNow' | localize }}</button>
        <div class="forgot-password d-flex justify-content-between">
          <a
            href="{{appBaseUrl}}/account/forgot-password"
            _target="blank"
            (click)="dismissLoginModal.emit()"
          >
            {{ 'ForgotPassword' | localize }}
          </a>
        </div>
      </ng-template>
      <ng-template #socialRegisterPending></ng-template>
      <ng-template #registerPending>
        @switch (currentRegisterStep) {
          @case (registerSteps.DoBSsn) {
            <div class="form-group">
              <label for="dateOfBirth">{{'DateOfBirth' | localize}} *</label>
              <nw-date-time-select
                inputId="DateOfBirth"
                name="DateOfBirth"
                (ngModelChange)="onSSN()"
                [(ngModel)]="registerInput.dateOfBirth"
                #DateOfBirthSelect="ngModel"
                (complete)="onDateOfBirthComplete('ssnLast')"
                required
              ></nw-date-time-select>
              @if (DateOfBirthSelect.dirty && DateOfBirthSelect.invalid) {
                @if (DateOfBirthSelect.hasError('required')) {
                  <small class="p-error">
                    {{'ThisFieldIsRequired' | localize}}
                  </small>
                }
              }
            </div>
            <div class="form-group" *ngIf="registerInput.countryId === sweden">
              <p-inputMask
                id="ssnLastDigits"
                inputId="ssnLast"
                styleClass="form-control"
                mask="9999"
                name="ssnLastDigits"
                [(ngModel)]="ssnLastDigits"
                #ssnInputModel="ngModel"
                (onBlur)="onSSN()"
                [placeholder]="'SsnPlaceHolder' | localize"
                ngDefaultControl
                required
              ></p-inputMask>
              @if (ssnInputModel.invalid && ssnInputModel.dirty) {
                @if (ssnInputModel.hasError('required')) {
                  <small class="p-error">
                    {{'ThisFieldIsRequired' | localize}}
                  </small>
                }
              }
            </div>
            <div class="row g-2">
              <div class="col-12 col-md-6">
                <button type="button" (click)="registerPrev()">{{ 'Back' | localize }}</button>
              </div>
              <div class="col-12 col-md-6">
                <button type="button" (click)="registerNext()" [disabled]="!loginForm.valid">{{ 'Next' | localize }}</button>
              </div>
            </div>
          }
          @default {
            <div class="form-group">
              <input
                type="text"
                [placeholder]="'Name' | localize"
                class="form-control"
                [(ngModel)]="registerInput.firstname"
                id="FirstName"
                name="FirstName"
                #FirstName="ngModel"
                required
              >
              @if (FirstName.invalid && FirstName.dirty) {
                @if (FirstName.hasError('required')) {
                  <small class="p-error">
                    {{'ThisFieldIsRequired' | localize}}
                  </small>
                }
              }
            </div>
            <div class="form-group">
              <input
                type="text"
                [placeholder]="'Surname' | localize"
                class="form-control"
                [(ngModel)]="registerInput.lastname"
                id="Surname"
                name="Surname"
                #Surname="ngModel"
                required
              >
              @if (Surname.invalid && Surname.dirty) {
                @if (Surname.hasError('required')) {
                  <small class="p-error">
                    {{'ThisFieldIsRequired' | localize}}
                  </small>
                }
              }
            </div>
            <div class="form-group">
              <nw-phone-number
                #phoneNumberInput
                [(phoneNumber)]="registerInput.phoneNumber"
                [inputRequired]="true"
                [cssClass]="'form-control'"
                name="PhoneNumber"
                ngDefaultControl
              ></nw-phone-number>
              @if (phoneNumberInput.control.invalid && (phoneNumberInput.control.dirty)) {
                @if (phoneNumberInput.control.hasError('required')) {
                  <small class="p-error" >
                    {{ 'ThisFieldIsRequired' | localize }}
                  </small>
                }
              }
            </div>
            <div class="form-group">
              <input
                type="email"
                [placeholder]="'Email' | localize"
                class="form-control"
                autocomplete="off"
                email
                id="Email"
                name="Email"
                [(ngModel)]="email"
                #Email="ngModel"
              />
              @if (Email.invalid && Email.dirty) {
                @if(Email.hasError('required')) {
                  <small class="p-error">
                    {{'ThisFieldIsRequired' | localize}}
                  </small>
                }
                @if (Email.hasError('email')) {
                  <small class="p-error">
                    {{'InvalidEmailAddress' | localize}}
                  </small>
                }
              }
            </div>
            @if (!isUnder18YearsOld) {
              <div class="form-group">
                <input
                  type="password"
                  [placeholder]="'Password' | localize"
                  class="form-control"
                  id="PasswordRegister"
                  name="Password"
                  autocomplete="off"
                  [(ngModel)]="registerInput.password"
                  #Password="ngModel"
                />
                @if (Password.invalid && Password.dirty) {
                  @if (Password.hasError('required')) {
                    <small class="p-error">
                      {{'ThisFieldIsRequired' | localize}}
                    </small>
                  }
                }
              </div>
              <div class="form-group">
                <input
                  type="password"
                  autocomplete="off"
                  [placeholder]="'ConfirmPassword' | localize"
                  class="form-control"
                  id="ConfirmPassword"
                  name="ConfirmPassword"
                  [(ngModel)]="confirmPassword"
                  #ConfirmPassword="ngModel"
                  validateEqual="Password"
                  required
                />
                @if (ConfirmPassword.invalid && ConfirmPassword.dirty) {
                  @if (ConfirmPassword.hasError('required')) {
                    <small class="p-error" *ngIf="ConfirmPassword.hasError('required')">
                      {{'ThisFieldIsRequired' | localize}}
                    </small>
                  }
                  @if(!ConfirmPassword.hasError('required') && ConfirmPassword.hasError('validateEqual')) {
                    <small class="p-error">
                      {{'PairsDoNotMatch' | localize}}
                    </small>
                  }
                }
              </div>
            }
            <div class="form-group p-fluid">
              <p-dropdown
                [options]="genders"
                [(ngModel)]="registerInput.genderId"
                #genderModel="ngModel"
                optionLabel="label"
                optionValue="value"
                name="Gender"
                id="nationality"
                [placeholder]="'Gender' | localize"
                filterBy="label"
                [filter]="true"
                [filterLocale]="appLocale"
                required
              >
              </p-dropdown>
              @if (genderModel.invalid && genderModel.dirty) {
                @if (genderModel.hasError('required')) {
                  <small class="p-error">
                    {{'ThisFieldIsRequired' | localize}}
                  </small>
                }
              }
            </div>
            <div class="form-group">
              <input
                type="text"
                [placeholder]="'Address' | localize"
                class="form-control"
                [(ngModel)]="registerInput.address"
                id="Address"
                name="Address"
                #Address="ngModel"
                #addressInput
                ngx-gp-autocomplete
                (onAddressChange)="handleAddressChange($event, addressInput)"
              >
            </div>
            <div class="row g-2">
              <div class="col-12 col-md-6">
                <button type="button" (click)="registerPrev()">{{ 'Back' | localize }}</button>
              </div>
              <div class="col-12 col-md-6">
                <button
                  type="button"
                  [buttonBusy]="registering"
                  (click)="tryRegister(loginForm.form.valid)"
                >
                  {{ 'RegisterNow' | localize }}
                </button>
              </div>
            </div>
          }
        }
      </ng-template>
  </ng-template>

  </form>
</div>
